import { IAuditEntityData } from 'src/app/core/interfaces/iaudit-entity-data';
import { AddressUtils } from 'src/app/core/utils/address-utils';
import { EntityUtilsService } from 'src/app/core/utils/entity-utils.service';
import { EntityName } from '../../enumerations/entity-name';
import { OperationType } from '../../enumerations/operation-type';
import { Boilers } from '../save/boilers';
import { BoilersFuelDisplay } from './boilers-fuel-display';

export class BoilersDisplay extends Boilers {

    plantId: number;
    areaId: number | null;
    unitName: string;
    unitStatus: string;
    plantName: string;
    physAddressV1: string;
    physAddressV2: string;
    phoneNo: string;
    phoneNoV1: string;
    manufacturerName: string;
    aecFirmName: string;
    designFirmName: string;
    constructorFirmName: string;
    areaName: string;
    physCity: string;
    physState: string;
    physStateName: string;
    physPostalCode: string;
    physCountry: string;
    physCountryName: string;
    plantOffshore: boolean | null;
    offshoreBlockV1: string;
    offshoreWaterbodyName: string;
    offshoreFieldName: string;
    offshoreAreaName: string;
    ownerId: number | null;
    ownerName: string;
    lastUserEmailAddress: string;
    entryUserEmailAddress: string;
    previousUserEmailAddress: string;
    qcUserEmailAddress: string;
    releaseUserEmailAddress: string;
    amendmentUserEmailAddress: string;
    lastUpdateStatus: string;
    modelLiveData: string;
    manufacturerIdLiveData: number;
    
    boilersFuelDisplay: Array<BoilersFuelDisplay> = [];

    constructor(entity?: any) {
        super(entity);

        this.plantId = entity?.plantId ?? '';
        this.areaId = entity?.areaId ?? '';
        this.unitName = entity?.unitName ?? '';
        this.unitStatus = entity?.unitStatus ?? '';
        this.plantName = entity?.plantName ?? '';
        this.physAddressV1 = entity?.physAddressV1 ?? '';
        this.physAddressV2 = entity?.physAddressV2 ?? '';
        this.phoneNo = entity?.phoneNo ?? '';
        this.phoneNoV1 = entity?.phoneNoV1 ?? '';
        this.manufacturerName = entity?.manufacturerName ?? '';
        this.aecFirmName = entity?.aecFirmName ?? '';
        this.designFirmName = entity?.designFirmName ?? '';
        this.constructorFirmName = entity?.constructorFirmName ?? '';
        this.areaName = entity?.areaName ?? '';
        this.physCity = entity?.physCity ?? '';
        this.physState = entity?.physState ?? '';
        this.physStateName = entity?.physStateName ?? '';
        this.physPostalCode = entity?.physPostalCode ?? '';
        this.physCountry = entity?.physCountry ?? '';
        this.physCountryName = entity?.physCountryName ?? '';
        this.plantOffshore = entity?.plantOffshore ?? null;
        this.offshoreBlockV1 = entity?.offshoreBlockV1 ?? '';
        this.offshoreWaterbodyName = entity?.offshoreWaterbodyName ?? '';
        this.offshoreFieldName = entity?.offshoreFieldName ?? '';
        this.offshoreAreaName = entity?.offshoreAreaName ?? '';
        this.ownerId = entity?.ownerId ?? '';
        this.ownerName = entity?.ownerName ?? '';
        this.lastUserEmailAddress = entity?.lastUserEmailAddress ?? '';
        this.entryUserEmailAddress = entity?.entryUserEmailAddress ?? '';
        this.previousUserEmailAddress = entity?.previousUserEmailAddress ?? '';
        this.qcUserEmailAddress = entity?.qcUserEmailAddress ?? '';
        this.releaseUserEmailAddress = entity?.releaseUserEmailAddress ?? '';
        this.amendmentUserEmailAddress = entity?.amendmentUserEmailAddress ?? '';
        this.lastUpdateStatus = entity?.lastUpdateStatus ?? '';
        this.modelLiveData = entity?.modelLiveData ?? '';
        this.manufacturerIdLiveData = entity?.manufacturerIdLiveData ?? '';

        this.boilersFuelDisplay = entity?.boilersFuelDisplay ?? [];

        this.initialData = entity;
    }

    static BuildEntityDisplay(entity: any): BoilersDisplay {
        entity = EntityUtilsService.convertUTCDates(entity);
        return new BoilersDisplay(entity);
    }

    static BuildNewEntity(response: any): BoilersDisplay {
        return new BoilersDisplay({
            boilerId: response[0].BOILER_ID,
            operation: OperationType.INSERT,
            intDataDepValState: OperationType.INSERT
        });
    }

    get auditEntityBean(): IAuditEntityData {
        return {
            lastUser: this.lastUser,
            entryUser: this.entryUser,
            prevUser: this.prevUser,
            qcUser: this.qcUser,
            lastDate: this.lastDate,
            entryDate: this.entryDate,
            prevDate: this.prevDate,
            qcDate: this.qcDate,
            releaseUser: this.releaseUser,
            releaseDate: this.releaseDate,
            amendmentUser: this.amendmentUser,
            amendmentDate: this.amendmentDate,
            lastUserEmailAddress: this.lastUserEmailAddress,
            entryUserEmailAddress: this.entryUserEmailAddress,
            previousUserEmailAddress: this.previousUserEmailAddress,
            qcUserEmailAddress: this.qcUserEmailAddress,
            releaseUserEmailAddress: this.releaseUserEmailAddress,
            amendmentUserEmailAddress: this.amendmentUserEmailAddress,
            lastUpdateStatus: this.lastUpdateStatus,
            entityName: EntityName.BOILER,
            entityId: this.boilerId
        };
    }

    prepareSaveCollection() {

        this.boilersFuel = this.boilersFuelDisplay;
    }

    applyChangedFields(changeObj: any) {
        this.changedFields = {};

        for(const field in changeObj) {
            if(this.hasOwnProperty(field)) {
                this.changedFields[field] = 0;
            }
        }
    }

    getPhysAddressV1():string {
        if(this.plantOffshore) {
            return this.offshoreBlockV1;
        } else {
            return this.physAddressV1;
        }
    }

    getPhysAddressV2():string {
        if(this.plantOffshore) {
            return AddressUtils.formatOffshorePhysAddressV2(
                this.offshoreFieldName,
                this.offshoreWaterbodyName,
                '');
        } else {
            return AddressUtils.formatPhysAddressV2(this.physCity,
                this.physState, this.physPostalCode, this.physCountryName);
        }
    }


}

